export const ap_table_header = [
  { title: 'Cost/ Product' },
  { title: 'Project/ Description' },
  { title: 'Client' },
  // { title: 'LOB' },
  { id: 'cost', title: 'Cost Amount', right: true, sort: true },
  { id: 'start_date', title: 'Start Date', sort: true },
  { title: '' },
  { id: 'end_date', title: 'End Date', sort: true },
  { title: 'Status' },
  { id: 'updated', title: 'Last Updated', sort: true },
]

export const ar_table_header = [
  { title: 'Proj./ Process' },
  { title: 'LOB/ Client' },
  { title: 'Key PM' },
  { title: 'Milestone' },
  { id: 'exc_vat', title: 'Amount', subtitle: '(Exc. VAT)', right: true, sort: true },
  { id: 'invoice_date', title: 'Due Date', sort: true },
  { id: 'cash_receive_date', title: 'Cash Receive', sort: true },
  { title: 'Status' },
  { id: 'updated', title: 'Last Updated', sort: true },
]

export const status = [
  {
    label: 'Planning',
    value: 'PLANNING',
    color: '#C4C4C4',
    bg: 'rgba(196, 196, 196, 0.16)',
    description: 'PM created billing planning',
  },
  {
    label: 'Delivered',
    value: 'DELIVERED',
    color: '#428BCA',
    bg: 'rgba(66, 139, 202, 0.16)',
    description: 'Invoiced date delivered to client',
  },
  {
    label: 'Issuing',
    value: 'ISSUING',
    color: '#9BA3AB',
    bg: 'rgba(155, 163, 171, 0.16)',
    description: 'Invoice issued by accounting',
  },
  {
    label: 'Invoiced',
    value: 'INVOICED',
    color: '#F0AD4E',
    bg: 'rgba(240, 173, 78, 0.16)',
    description: 'Client confirm payment date',
  },
  {
    label: 'Paid',
    value: 'PAID',
    color: '#6FCF97',
    bg: 'rgba(111, 207, 151, 0.16)',
    description: 'Client has paid',
  },
]


export const ap_status = [
  {
    label: 'Unpaid',
    value: 'UNPAID',
    color: '#C4C4C4',
    bg: 'rgba(196, 196, 196, 0.16)',
  },
  {
    label: 'Paid',
    value: 'PAID',
    color: '#6FCF97',
    bg: 'rgba(111, 207, 151, 0.16)',
  },
]

export const credit_term = [
  { label: '15', value: '15' },
  { label: '30', value: '30' },
  { label: '45', value: '45' },
  { label: '90', value: '90' },
]

export const ap_types = [
  { label: 'AP Due Date', value: 0 },
  { label: 'AP Paid', value: 1 },
  { label: 'All Status', value: 2 },
]

export const ar_types = [
  { label: 'Planning', value: 0 },
  { label: 'Delivered', value: 1 },
  { label: 'Issuing', value: 2 },
  { label: 'Invoiced', value: 3 },
  { label: 'Paid', value: 4 },
  { label: 'All Status', value: 5 },
]

export const vatOptions = [
  { label: '0%', value: '0' },
  { label: '3%', value: '3' },
  { label: '5%', value: '5' },
  { label: '7%', value: '7' },
  { label: '10%', value: '10' },
  { label: '15%', value: '15' },
]



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/constants.js